import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { authStorage } from '../utils/authStorage';

/**
 * Protects routes that require authentication.
 * Redirects to / (login) if no session.
 */
function PrivateRoute({ component: Component, ...rest }) {
  const loginData = authStorage.getLoginData();
  const isAuthenticated = !!loginData && typeof loginData === 'object';
  const isDirectLpAccess =
    rest.path === '/lp-dashboard' &&
    (() => {
      try {
        const params = new URLSearchParams(window.location.search);
        return !!params.get('access');
      } catch {
        return false;
      }
    })();

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated || isDirectLpAccess ? (
          <Component {...props} />
        ) : (
          <Redirect to={{ pathname: '/', state: { from: props.location } }} />
        )
      }
    />
  );
}

export default PrivateRoute;
